import { dispatchToTrackersInCollection } from '@mailbiz/browser-tracker-core';
import { buildAddToCart, buildCartSync, buildCartItemUpdate, buildCartSetPostalCode, buildCartSetCoupon, buildCheckoutStep, buildOrderComplete, buildOrderCancel, buildProductView } from '@mailbiz/tracker-core';

var _trackers = {};
/**
 * Adds ecommerce and cart tracking
 */
function EcommercePlugin() {
    return {
        activateBrowserPlugin: function (tracker) {
            _trackers[tracker.id] = tracker;
            // _transactions[tracker.id] = ecommerceTransactionTemplate();
        }
    };
}
/**
 * Track an add-to-cart event
 *
 * @param event - The event information
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackAddToCart(event, trackers) {
    if (trackers === void 0) { trackers = Object.keys(_trackers); }
    dispatchToTrackersInCollection(trackers, _trackers, function (t) {
        t.core.track(buildAddToCart(event));
    });
}
/**
 * Track a cart sync event
 *
 * @param event - The event information
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackCartSync(event, trackers) {
    if (trackers === void 0) { trackers = Object.keys(_trackers); }
    dispatchToTrackersInCollection(trackers, _trackers, function (t) {
        t.core.track(buildCartSync(event));
    });
}
/**
 * Track a cart item update quantity
 *
 * @param event - The event information
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackCartItemUpdate(event, trackers) {
    if (trackers === void 0) { trackers = Object.keys(_trackers); }
    dispatchToTrackersInCollection(trackers, _trackers, function (t) {
        t.core.track(buildCartItemUpdate(event));
    });
}
/**
 * Track a cart set postal code
 *
 * @param event - The event information
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackCartSetPostalCode(event, trackers) {
    if (trackers === void 0) { trackers = Object.keys(_trackers); }
    dispatchToTrackersInCollection(trackers, _trackers, function (t) {
        t.core.track(buildCartSetPostalCode(event));
    });
}
/**
 * Track a cart set coupon
 *
 * @param event - The event information
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackCartSetCoupon(event, trackers) {
    if (trackers === void 0) { trackers = Object.keys(_trackers); }
    dispatchToTrackersInCollection(trackers, _trackers, function (t) {
        t.core.track(buildCartSetCoupon(event));
    });
}
/**
 * Track a checkout set step
 *
 * @param event - The event information
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackCheckoutStep(event, trackers) {
    if (trackers === void 0) { trackers = Object.keys(_trackers); }
    dispatchToTrackersInCollection(trackers, _trackers, function (t) {
        t.core.track(buildCheckoutStep(event));
    });
}
/**
 * Track a order completed event
 *
 * @param event - The event information
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackOrderComplete(event, trackers) {
    if (trackers === void 0) { trackers = Object.keys(_trackers); }
    dispatchToTrackersInCollection(trackers, _trackers, function (t) {
        t.core.track(buildOrderComplete(event));
    });
}
/**
 * Track a order cancel event
 *
 * @param event - The event information
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackOrderCancel(event, trackers) {
    if (trackers === void 0) { trackers = Object.keys(_trackers); }
    dispatchToTrackersInCollection(trackers, _trackers, function (t) {
        t.core.track(buildOrderCancel(event));
    });
}
/**
 * Track a product view event
 *
 * @param event - The event information
 * @param trackers - The tracker identifiers which the event will be sent to
 */
function trackProductView(event, trackers) {
    if (trackers === void 0) { trackers = Object.keys(_trackers); }
    dispatchToTrackersInCollection(trackers, _trackers, function (t) {
        t.core.track(buildProductView(event));
    });
}

export { EcommercePlugin, trackAddToCart, trackCartItemUpdate, trackCartSetCoupon, trackCartSetPostalCode, trackCartSync, trackCheckoutStep, trackOrderCancel, trackOrderComplete, trackProductView };
//# sourceMappingURL=index.module.js.map
